<template>
  <div id="dashboard">
    <account-side-menu></account-side-menu>
    <div id="board-content">
      <keep-alive>
        <transition>
          <router-view></router-view>
        </transition>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import AccountSideMenu from "@/components/fixed/account-side-menu";

export default {
  components: {
    AccountSideMenu
  }
};
</script>

<style scoped lang="css">
#dashboard {
  display: flex;
}

#board-content {
  flex-grow: 1;
  /* height: 100vh; */
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/board/dash-board.vue